import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Divider from '@mui/material/Divider';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import "./notification.css";
import Authapi from "../Services/Authapi";
import ls from "local-storage";
import swal from "sweetalert";
// import Grid from "@material-ui/core/Grid";
import Switch from '@material-ui/core/Switch';
import Tooltip from "@material-ui/core/Tooltip";
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as GiIcons from 'react-icons/gi';
import { ThemeContext } from '../../ThemeContext';
// import * as AiIcons from 'react-icons/ai';
// import * as BiIcons from "react-icons/bi";
// import * as RiIcons from "react-icons/ri";
// import * as CgIcons from "react-icons/cg";
// import * as BsIcons from "react-icons/bs";
// import * as FiIcons from "react-icons/fi";
// import * as IoIcons from "react-icons/io5";
// import * as HiIcons from "react-icons/hi";
// import * as GrIcons from "react-icons/gr";
// import * as DiIcons from "react-icons/di";
import ClearAllIcon from '@mui/icons-material/ClearAll';

const allIcons = {
  ...FaIcons,
  ...MdIcons,
  ...GiIcons,
  // ...AiIcons,
  // ...BiIcons,
  // ...RiIcons,
  // ...CgIcons,
  // ...BsIcons,
  // ...FiIcons,
  // ...IoIcons,
  // ...HiIcons,
  // ...GrIcons,
  // ...DiIcons, 
  // Add more icon packs here if needed
};
const notificationHeaderBlue = "#036dda";
const iconStyle = { color: notificationHeaderBlue, marginRight: '8px' };

const defaultIcons = {
  "Leave Ticket": <i className="fas fa-ticket-alt" style={iconStyle}></i>,
  "Birthday": <i className="fas fa-birthday-cake" style={iconStyle}></i>,
  "Leave Status": <i className="fas fa-ticket-alt" style={iconStyle}></i>,
  "Upcoming Event": <i className="fa fa-arrow-right" style={iconStyle}></i>,
  "Resign-Letter": <i className="fa fa-sign-out" style={iconStyle}></i>,
  "Salary-Slip": <i className="fas fa-balance-scale" style={iconStyle}></i>,
  "Time-Entry": <i className="far fa-times-circle" style={iconStyle}></i>,
  "New Holiday": <i className="fas fa-sign-out-alt" style={iconStyle}></i>,
  "Time-Entry Status": <i className="far fa-times-circle" style={iconStyle}></i>,
  "Task Update": <i className="fas fa-clipboard-list" style={iconStyle}></i>,
  "New Task": <i className="fas fa-tasks" style={iconStyle}></i>,
};

function notificationsLabel(count) {
  if (count === 0) {
    return "no notifications";
  }
  if (count > 99) {
    return "more than 99 notifications";
  }
  return `${count} notifications`;
}

function formatDate(dateString) {
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata"
  };
  return new Intl.DateTimeFormat("en-GB", options).format(new Date(dateString)).replace(/\//g, '-');
}

const NotificationComponent = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notifications, setNotifications] = useState({});
  const [loading, setLoading] = useState(true);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [notificationIcons, setNotificationIcons] = useState({});
  const [switchState, setSwitchState] = useState(() => {
    const savedStatus = ls.get('notificationStatus');
    return savedStatus !== null ? savedStatus === 1 : props.authUser?.user?.Notification_Status === 1;
  });
  const history = useHistory();
  const User = ls("user");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // console.log(props.authUser.user?.id)

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (window.Notification && window.Notification.permission !== "granted") {
      window.Notification.requestPermission();
    }

    const handleCustomNotification = (e) => {
      if (e && e.detail) {
        const { title, message, type } = e.detail;
        const notifType = type || "Leave Ticket";
        setNotifications((prev) => {
          const prevList = (prev && prev[notifType]) || [];
          const newNotif = {
            id: "local_" + Date.now(),
            notification: message ? (title ? `${title}: ${message}` : message) : title,
            type: notifType,
            created_at: new Date().toISOString(),
            is_view: 1,
            is_read: 0,
          };
          return {
            ...(prev || {}),
            [notifType]: [newNotif, ...prevList],
          };
        });
      }
    };

    const handleRefreshNotifications = () => {
      fetchData();
    };

    window.addEventListener("cherrypik_new_notification", handleCustomNotification);
    window.addEventListener("cherrypik_refresh_notifications", handleRefreshNotifications);

    const currentStatus = props.authUser?.user?.Notification_Status;
    if (currentStatus !== undefined) {
      setSwitchState(currentStatus === 1);
      ls.set('notificationStatus', currentStatus);
    }

    const handleVisibilityChange = () => {
      if (typeof document !== "undefined" && !document.hidden) {
        fetchData();
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 120000);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("cherrypik_new_notification", handleCustomNotification);
      window.removeEventListener("cherrypik_refresh_notifications", handleRefreshNotifications);
    };
  }, [props.authUser?.user?.Notification_Status]);

  const fetchData = async () => {
    if (typeof document !== "undefined" && document.hidden) return;
    const user = ls("user");
    const authToken = ls("authToken");
    if (!user || !authToken) return;

    setLoading(true);
    try {
      let notificationsData = ls("roles") === "Super Admin"
        ? await Authapi.Notification()
        : await Authapi.NotificationEmployee();

      if (notificationsData && typeof notificationsData === "object") {
        const filtered = {};
        Object.keys(notificationsData).forEach((type) => {
          const seenKeys = new Set();
          const list = (notificationsData[type] || []).filter((item) => {
            const msg = String(item.notification || "").toLowerCase();
            if (msg.includes("a new calendar event")) return false;

            const uniqueKey = item.id ? String(item.id) : `${item.notification}_${item.created_at}`;
            if (seenKeys.has(uniqueKey)) return false;
            seenKeys.add(uniqueKey);
            return true;
          });
          if (list.length > 0) {
            filtered[type] = list;
          }
        });
        notificationsData = filtered;
      }

      setNotifications(notificationsData);

      const initialExpandedGroups = {};
      Object.keys(notificationsData).forEach(type => {
        initialExpandedGroups[type] = true;
      });
      setExpandedGroups(initialExpandedGroups);
      const iconsResponse = await Authapi.getNotificationIcons();
      if (iconsResponse) {
        const transformedIcons = {};
        Object.keys(iconsResponse).forEach(key => {
          transformedIcons[key.replace(/_/g, ' ')] = iconsResponse[key];
        });
        setNotificationIcons(transformedIcons);
      }
      if (notificationsData) {
        Object.keys(notificationsData).forEach(type => {
          notificationsData[type].forEach(async notification => {
            if (notification.is_view === 0) {
              const notifType = String(notification.type || type || "").toLowerCase();
              const isCalendarOrEventNotif = notifType.includes("event") || notifType.includes("meeting") || notifType.includes("calendar");

              if (!isCalendarOrEventNotif && props.authUser.user?.Notification_Status == 1) {
                showDesktopNotification(notification);
              }
              await Authapi.Notificationview(notification.id);
            }
          });
        });
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = async (notification) => {
    try {
      await Authapi.Notificationread(notification.id);
      const notificationData = { id: notification.id, type: notification.type, dataId: notification.data_id };
      sessionStorage.setItem('fromNotificationPanel', 'true');

      switch (notification.type) {
        case "Leave Ticket":
        case "Leave Status":
          history.push({
            pathname: "/leave-tickets",
            state: { notificationData }
          });
          break;
        case "Time-Entry":
        case "Time-Entry Status":
          history.push({
            pathname: "/time-entries",
            state: { notificationData }
          });
          break;
        case "Upcoming Event":
          const eventId = notification.data_id;
          sessionStorage.setItem('openEventModal', 'true');
          history.push({
            pathname: "/dashboard",
            state: { eventId }
          });
          break;
        case "New Holiday":
          const dateMatch = notification.notification.match(/\d{2}-\d{2}-\d{4}/);
          if (dateMatch) {
            const date = dateMatch[0];
            sessionStorage.setItem('openHolidayModal', 'true');
            history.push({
              pathname: "/holiday-leaves",
              state: { date }
            });
          }
          break;
        case "Resign-Letter":
          history.push("/Relievingletter");
          break;
        case "Birthday":
          history.push("/dashboard");
          break;
        case "Salary-Slip":
          const salarySlipPath =
            ls("roles") === "Super Admin"
              ? `/users/${notification.user_id}`
              : "/profile";
          sessionStorage.setItem('openSalaryModal', 'true');
          history.push({
            pathname: salarySlipPath,
            state: { tab: "salaryInfo", salarySlipId: notification.data_id }
          });
          break;
        case "Task Update":
        case "New Task":
          history.push({
            pathname: "/tasks",
            // state: { taskId: notification.data_id }
          });
          break;
        case "Project Activity":
        case "Projectactivity":
        case "Project-Activity":
        case "project activity":
        case "project_activity":
          // Open specific project details; data_id expected to be project id
          if (notification.data_id) {
            history.push({
              pathname: `/project/${notification.data_id}`,
            });
          } else {
            history.push({ pathname: "/project" });
          }
          break;
        case "Issue Activity":
        case "Issueactivity":
        case "Issue-Activity":
        case "issue activity":
        case "issue_activity":
          // Parse data_id JSON to get project_id and issue_id
          try {
            const dataIdObj = typeof notification.data_id === 'string' 
              ? JSON.parse(notification.data_id) 
              : notification.data_id;
            
            if (dataIdObj && dataIdObj.project_id && dataIdObj.issue_id) {
              history.push({
                pathname: `/project/${dataIdObj.project_id}`,
                state: { tab: 'issues', openIssueId: dataIdObj.issue_id }
              });
            } else {
              // Fallback: go to project list if parsing fails
              history.push({ pathname: "/project" });
            }
          } catch (error) {
            console.error("Error parsing notification data_id:", error);
            // Fallback: go to project list if parsing fails
            history.push({ pathname: "/project" });
          }
          break;
        default:
          break;
      }
      handleClose();
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleExpandClick = (type) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const renderNotificationsByType = (type, darkMode) => {
    return notifications[type].map((notification, index) => (
      <Card
        key={notification.id}
        onClick={() => handleNotificationClick(notification)}
        style={{
          marginBottom: '10px',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
          position: 'relative',
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = darkMode ? '#2a2a2a' : '#f0f0f0'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = darkMode ? '#1e1e1e' : 'white'}
      >
        <CardContent>
          <Typography variant="body2" component="p" style={{ color: darkMode ? '#ffffff' : 'inherit' }}>
            {index + 1}. {notification.notification}
          </Typography>
          <Typography 
            variant="caption" 
            style={{ 
              position: 'absolute', 
              bottom: '1px', 
              left: '172px',
              color: darkMode ? notificationHeaderBlue : 'rgba(0, 0, 0, 0.6)'
            }}
          >
            {formatDate(notification.created_at)}
          </Typography>
        </CardContent>
      </Card>
    ));
  };

  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];
  const showDesktopNotification = (notification) => {
    if (window.Notification && window.Notification.permission === "granted") {
      const desktopNotification = new window.Notification("Cherrypik Software", {
        body: notification.notification,
        icon: "/logo.png",
      });
      desktopNotification.onclick = () => {
        window.focus();
        history.push({
          pathname: "/detailed-notifications"
        })
      };
    }
  };

  const handleMarkAllAsRead = async () => {
    if (ls("roles") === "Super Admin") {
      try {
        const willProceed = await swal({
          title: "Are you sure?",
          text: "Do you want to mark all notifications as read?",
          icon: "warning",
          buttons: ["Cancel", "Confirm"],
          dangerMode: true,
        });
        if (willProceed) {
          swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          const response = await Authapi.notificationsalladmin();
          if (response && response.status === true) {
            fetchData();
            swal("Success", "All notifications marked as read!", "success");
          } else {
            swal("Error", "Failed to mark all notifications as read.", "error");
          }
        } else {
          swal("Cancelled", "The action was cancelled.", "info");
        }
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
        swal("Error", "Failed to mark all notifications as read.", "error");
      }
    } else {
      try {
        const willProceed = await swal({
          title: "Are you sure?",
          text: "Do you want to mark all notifications as read?",
          icon: "warning",
          buttons: ["Cancel", "Confirm"],
          dangerMode: true,
        });
        if (willProceed) {
          swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          const response = await Authapi.notificationsallemployee();
          if (response && response.status === true) {
            fetchData();
            swal("Success", "All notifications marked as read!", "success");
          } else {
            swal("Error", "Failed to mark all notifications as read.", "error");
          }
        } else {
          swal("Cancelled", "The action was cancelled.", "info");
        }
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
        swal("Error", "Failed to mark all notifications as read.", "error");
      }
    }
  }

  const statusRow = async (id, status) => {
    const confirm = await swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    });
    if (confirm) {
      swal({
        title: "Loading",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        width: "10%",
        content: {
          element: "img",
          attributes: {
            src: "https://www.boasnotas.com/img/loading2.gif",
            style: "width: 50px;"
          }
        }
      });
      try {
        let statu = await Authapi.NotificationStatus(id, status);
        swal.close();
        if (statu && statu.status === true) {
          setSwitchState(status === 1);
          ls.set('notificationStatus', status);
          if (props.userData) {
            await props.userData();
          }
          // Refresh the page to ensure all states are in sync
          window.location.reload();
        }
      } catch (error) {
        console.error('Error updating user status:', error);
        swal("Error", "Failed to update notification status", "error");
      }
    }
  }

  return (
    <ThemeContext.Consumer>
      {({ darkMode }) => (
    <div>
  <IconButton
  aria-describedby={id}
  aria-label={notificationsLabel(Object.keys(notifications).flatMap(key => notifications[key]).length)}
  className="notification-icon-button"
  style={{
    position: "absolute",
    right: "56px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "white",
    padding: "6px",
    width: "36px",
    height: "36px",
    overflow: "visible",
    borderRadius: "50%",
  }}
  onClick={handleClick}
>
  <Badge 
    badgeContent={Object.keys(notifications).flatMap(key => notifications[key]).length} 
    color="info"
    className="notification-count-badge"
    overlap="circular"
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
  >
    <NotificationsIcon htmlColor="#ffffff" />  
  </Badge>
</IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            // padding: 2,
            borderRadius: 10,
          },
        }}
        disableScrollLock
      >
        <div
          style={{
            padding: '16px',
            background: `linear-gradient(180deg, var(--hrms-primary-blue-start, ${notificationHeaderBlue}) 0%, var(--hrms-primary-blue-end, ${notificationHeaderBlue}) 100%)`,
            color: 'white',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <NotificationsActiveIcon style={{ marginRight: '8px' }} />
          <Typography variant="h6" style={{ margin: 0 }}>
            Notifications
          </Typography>

          <Tooltip title={switchState ? "Notification Off" : "Notification On"}>
            <label
              style={{
                position: "absolute",
                right: "55px"
              }}
            >
              <Switch
                onClick={(e) => statusRow(props.authUser.user?.id, switchState ? 0 : 1)}
                checked={switchState} />
            </label>
          </Tooltip>
          <IconButton
  onClick={() => handleMarkAllAsRead()}
  style={{
    color: "#ffffff",  
    left: "130px"
  }}
  title="Clear Notifications"
>
  <ClearAllIcon htmlColor="#ffffff" />  
</IconButton>

        </div>
        <Divider />
        <Typography sx={{ p: 2 }} style={{ height: "400px", width: "350px", overflowY: "auto" }}>
          {loading ? (
            <p>Loading...</p>
          ) : (
            Object.keys(notifications).length > 0 ? (
              Object.keys(notifications).map((type) => (
                <div key={type}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {allIcons[notificationIcons[type]]
                        ? React.createElement(allIcons[notificationIcons[type]], { style: iconStyle })
                        : defaultIcons[type]}
                      <Typography variant="subtitle1" style={{ margin: 0 }}>
                        {type}
                      </Typography>
                    </div>
                    {Object.keys(notifications).length > 1 && (
                      <IconButton onClick={() => handleExpandClick(type)}>
                        {expandedGroups[type] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    )}
                  </div>
                  {expandedGroups[type] && renderNotificationsByType(type, darkMode)}
                  <Divider />
                </div>
              ))
            ) : (
              <p>No notifications available</p>
            )
          )}
        </Typography>
        <Divider />
        {userpermissions.includes("DetailedNotifications.Show") && (
          <div style={{ padding: '8px', textAlign: 'center' }}>
            <Link to="/detailed-notifications" style={{ textDecoration: 'none' }}>
                     <Typography
                           variant="button"
                                         style={{
                                       color: notificationHeaderBlue,
                                           fontWeight: 800  
                                          }}
                                 >
                                             Show All Notifications
                  </Typography>
        </Link>

          </div>
        )}
      </Popover>
    </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default NotificationComponent;

